import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummary.js';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import storage from '@synergycms_core/utils/storage';
import { fromJS, List, Map } from 'immutable';
import {
  getPrepaymentText,
  getReservationTotals, isRefundable,
  parseServices,
  parseTaxes,
  getRoomName,
  reservationAvailQuery
} from '../../../utils';
import AvailMainSideSummaryServices from './Render/AvailMainSideSummaryServices';
import AvailMainSideSummaryHotel from './Render/AvailMainSideSummaryHotel';
import { getLoyaltyDiscount } from '../../../store/avail/availUtils';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';
import AvailMainSideSummaryRooms from './Render/AvailMainSideSummaryRooms';
import AvailMainSideSummaryHeader from './Render/AvailMainSideSummaryHeader';
import { getSTPoints } from '../../../store/customer/loyaltyUtils';
import AvailMainSideSummaryLoyaltyPoints from './Render/AvailMainSideSummaryLoyaltyPoints';
import AvailMainSideSummaryTaxes from './Render/AvailMainSideSummaryTaxes';
import { getPenalties } from '../../../utils/penalties';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';
import AvailMainSideSummaryPenalties from './Render/AvailMainSideSummaryPenalties';
import AvailMainSideSummaryReservation from './Render/AvailMainSideSummaryReservation';
import AvailMainSideSummaryHotelInfo from './Render/AvailMainSideSummaryHotelInfo';
import AvailMainSideSummaryLoyaltyDiscount from './Render/AvailMainSideSummaryLoyaltyDiscount';
import AvailMainSideSummaryPromoCodeDiscount from './Render/AvailMainSideSummaryPromoCodeDiscount';
import AvailMainSideSummaryTotalPrice from './Render/AvailMainSideSummaryTotalPrice';
import AvailMainSideSummaryEquivalentPrice from './Render/AvailMainSideSummaryEquivalentPrice';
import AvailMainSideSummaryRedeemPoints from './Render/AvailMainSideSummaryRedeemPoints';
import AvailMainSideSummaryGiftCodeDiscount from './Render/AvailMainSideSummaryGiftCodeDiscount';
import AvailMainSideSummaryPay from './Render/AvailMainSideSummaryPay';

const AvailMainSideSummary = class AvailMainSideSummary extends React.Component {
  static displayName = 'AvailMainSideSummary';


  render() {
    const { config, theme, content } = this.props,
      {
        // GENERAL
        reservationConfirmed = false,
        stepCode,
        hotelInfo,
        hotelAvail,
        reservationBlocks,
        showTaxes,
        hotelConfig,
        langActive,
        availHotel,
        forceHotelCurrency,
        reservationObj,

        // ROOMS
        totalAdults,
        totalChilds,
        childsInfo,
        staticRooms,
        nights,

        // SERVICES
        parsedServices,
        reservationTotals,

        // LOYALTY DISCOUNT
        loyaltyDiscount,
        loyaltyUser,
        loyalty,

        // PROMO CODE DISCOUNT
        promoCodeDiscount,
        promoCode,

        // GIFT CODE DISCOUNT
        giftCode,
        giftCodeDiscount,

        // REDEEM POINTS
        redeemPoints,

        // TOTAL PRICES
        refundable,
        payformCode,
        totalPointsPrice,

        // LOYALTY POINTS
        accumulatePoints,
        showFrontRedeemPoints,

        //PENALTIES
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        fullFreeReservation,
        currencies,
        langInfo,
        currentCurrencyCode,
        hotelCurrencyCode,
        managementGroupID,
      } = config;
    const { classes } = theme.styles;

    let showAvailPriceAs = hotelConfig.getIn(['show_avail_price_as', langActive,'translatable_value'], "total");


    var totalPriceRooms = reservationTotals.get('rooms_price');
    if(promoCodeDiscount) totalPriceRooms -= promoCodeDiscount;
    if(loyaltyDiscount) totalPriceRooms -= loyaltyDiscount;
    const groupedHotels =  [];

    if(hotelAvail) {
      const hotels = hotelAvail.keySeq().map(key => {
        const block = reservationBlocks.get(key, Map());
        const roomId = block.get('room_id');
        const serviceId = block.get('service_id');
        const boardId = block.get('board_id');
        const roomAvail = hotelAvail && hotelAvail.getIn([key, serviceId ? roomId + '-' + serviceId : roomId]);
        const boardAvail = roomAvail && roomAvail.getIn(['boards', boardId, block.get('ref_type')]);
        const adults = block.get('adults');
        const childs = block.get('childs');
        const babies = block.get('babies');
        const childsInfo = block.get('childs_info');

        // GET ROOM NAME + OCCUPANCY
        const roomSection = roomAvail && (
          staticRooms.find(
            r =>
              r.get('id') === roomAvail.get('room_id') &&
              r.get('occup_group_id') === roomAvail.get('occup_group_id') &&
              r.get('service_id') === roomAvail.get('service_id')
          ) ||
          staticRooms.find(
            r =>
              r.get('id') === roomAvail.get('room_id') &&
              r.get('occup_group_id') === r.get('default_occup_group_id') &&
              r.get('service_id') === roomAvail.get('service_id')
          )
        );
        const needAddOccupName = (roomSection && roomSection.get('occup_group_id') !== roomAvail.get('occup_group_id')) || childsInfo;
        let roomOccupName = getRoomName({ childs, adults, babies, childsInfo });
        let roomName = roomAvail && (roomSection && !childsInfo ? roomSection.get('name') : roomAvail.get('room_name'));
        if (needAddOccupName) roomName += roomOccupName;


        // GET ROOM PRICE
        var roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
        if(block.get('discount_amount')) roomPrice -= block.get('discount_amount');

        const discounts = block.get('discounts', List());
        if(discounts) {
          discounts.forEach(discount => {
            if(!discount.get('is_promotion_code') && !discount.get('is_corporate') && !discount.get('is_loyalty')) roomPrice += discount.get('amount');
          });
        }

        if (nights <= 1) showAvailPriceAs = 'total';
        const finalLowestPrices = [];
        let currentPriceIndex = 0;
        try {
          if (availHotel) {
            availHotel.forEach(block => {
              const blockRoom =
                block &&
                (
                  block.find(
                    r =>
                      r.get('room_id') === roomAvail.get('room_id') &&
                      r.get('service_id') === roomAvail.get('service_id') &&
                      r.get('board_id') === roomAvail.get('board_id')
                  )
                );

              if (blockRoom) {
                const board = blockRoom.getIn(['boards', boardId]);

                if (board) {
                  const dynamicKey = board.keySeq().first();
                  const days = board.getIn([dynamicKey, 'days']);

                  if (days) {
                    let lowestPrice = Infinity;
                    let lowestPriceTax = Infinity;

                    days.forEach((dayInfo, dayKey) => {
                      var price = dayInfo.get('price');
                      var priceTax = dayInfo.get('price_tax');


                      const discounts = dayInfo.get('discounts', List());
                      if(discounts) {
                        discounts.forEach(discount => {
                          if(discount.get('is_promotion_code') || discount.get('is_corporate') || discount.get('is_loyalty')) {
                            price -= discount.get('amount');
                            priceTax -= discount.get('amount');
                          }
                        });
                      }

                      if (price < lowestPrice) {
                        lowestPrice = price;
                      }

                      if (priceTax < lowestPriceTax) {
                        lowestPriceTax = priceTax;
                      }
                    });

                    const showTaxes = hotelInfo.get('show_taxes');
                    const finalPrice = showTaxes ? lowestPriceTax : lowestPrice;


                    finalLowestPrices.push(finalPrice);
                  }
                }
              }
            });
          }
        } catch (error) {
          console.error('Error occurred:', error);
          showAvailPriceAs = 'total';
        }

        let amount;
        let showAvailPriceAsText;



        switch (showAvailPriceAs) {
          case 'noche':
            showAvailPriceAsText = "_%por noche%_";
            if (currentPriceIndex < finalLowestPrices.length) {
              amount = finalLowestPrices[currentPriceIndex];
              currentPriceIndex++;
              // cal descomptar els descomptes de la reserva
            }
            break;
          case 'media':
            showAvailPriceAsText = "_%precio medio%_";
            amount = roomPrice / nights;
            break;
          default:
            showAvailPriceAsText = "";
            amount = roomPrice;
            break;
        }

        return {
          boardAvail,
          roomName,
          amount,
          forceHotelCurrency,
          showAvailPriceAsText
        }
      })

      hotels.forEach(hotel => {
        const index = groupedHotels.findIndex(groupedHotel => groupedHotel.roomName === hotel.roomName && groupedHotel.boardAvail.get('board_name') === hotel.boardAvail.get('board_name'));
        if (index === -1) {
          groupedHotels.push({
            roomName: hotel.roomName,
            boardAvail: hotel.boardAvail,
            boardName: hotel.boardAvail.get('board_name'),
            amount: hotel.amount,
            showAvailPriceAsText: hotel.showAvailPriceAsText,
            quantity: 1
          });
        } else {
          groupedHotels[index].quantity += 1;
          if(showAvailPriceAs !== 'noche') groupedHotels[index].amount += hotel.amount;
        }
      })
    }


    /********** TAXES **********/
    const summaryBreakdownMode = hotelConfig.get('summary_taxes_breakdown', 'default');
    const taxes = parseTaxes(hotelInfo, reservationObj,summaryBreakdownMode);






    /*********** PENALTIES **********/

    let penalties = null;
    let requiredPrepaymentCalc = 0;
    let requiredPrepaymentText = '';
    if (requiredPrepayment > 0 && !fullFreeReservation && refundable && currencies) {
      requiredPrepaymentCalc = requiredPrepayment;
      requiredPrepaymentText = getPrepaymentText(
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        currencies,
        currentCurrencyCode,
        hotelCurrencyCode,
        langInfo,
        content,
        forceHotelCurrency
      );
    }


    const rateSecureCancellation = reservationObj && reservationObj?.get('rates')?.some(d => d?.get('secure_cancellation', false));
    const discountSecureCancellation = reservationObj && reservationObj?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
    const serviceSecureCancellation = reservationObj && reservationObj?.get('services')?.some(d => d?.get('secure_cancellation', false));
    const pmsName = hotelInfo && hotelInfo.get('pms');
    const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;

    if (reservationObj) {
      penalties = getPenalties(reservationObj, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, null, managementGroupID);
    }
    const discountPercent = reservationTotals ? reservationTotals.get('discount_percent') : 0;

    const forceSymbol = stepCode === 'confirmation' ?
      hotelCurrencyCode === 'EUR' || hotelCurrencyCode === 'USD' || hotelCurrencyCode === 'GBP' :
      currentCurrencyCode === 'EUR' || currentCurrencyCode === 'USD' || currentCurrencyCode === 'GBP';

    const removeGap = !!(redeemPoints || giftCodeDiscount);

    const showBoxTaxes = taxes.nonIncluded.length > 0 || !!hotelInfo.get('city_tax');
    const showBoxPenalties = !!penalties;
    const showBoxHotelInfo = hotelInfo.get('country_iso_code') === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP;
    const nothingBelow = !showBoxTaxes && !showBoxPenalties && !showBoxHotelInfo;



    /********** TOTAL PRICE **********/
    const totalPrice = reservationTotals.get('total_price');

    let payments = []
    const isHotelPayment = refundable && !['op', 'paypal'].includes(payformCode);

    if(!!requiredPrepaymentCalc && isHotelPayment) {
      payments.push({
        text: '_%pagar ahora%_',
        amount: requiredPrepaymentCalc,
        isEquivalent: false
      });
    } else {
      payments.push({
        text: isHotelPayment ? '_%pagar en el hotel%_' : '_%pagar ahora%_',
        amount: totalPrice + giftCodeDiscount,
        isEquivalent: (!!redeemPoints || !!giftCodeDiscount) ? false : true,
      });
    }


    if (!!totalPointsPrice) {
      payments.push({
        text: '_%Pagar%_',
        amount: totalPrice - totalPointsPrice,
      });
    }


    return (
      <div className={theme.computedInnerStyle}>

        <div className={classes.availMainSideSummaryHeader}>
          <AvailMainSideSummaryHeader reservationConfirmed={reservationConfirmed} />
        </div>

        <div className={classes.separator}></div>

        <div className={classes.content}>

          <div className={classes.availMainSideSummaryHotel}>
            <AvailMainSideSummaryHotel totalAdults={totalAdults} totalChilds={totalChilds}/>
          </div>

          <div className={classes.separator}></div>

          <div className={classes.availMainSideSummaryReservation}>
            <AvailMainSideSummaryReservation totalAdults={totalAdults} totalChilds={totalChilds} childsInfo={childsInfo}/>
          </div>

          <div className={classes.separator}></div>

          <div className={classes.summaryBookingBox}>
            <AvailMainSideSummaryRooms totalPriceRooms={totalPriceRooms} groupedRooms={groupedHotels} forceSymbol={forceSymbol} />

            {Object.keys(parsedServices).length !== 0 && (
              <AvailMainSideSummaryServices parsedServices={parsedServices} totalPriceServices={reservationTotals?.get('services_price')} forceSymbol={forceSymbol} />
            )}

            {!!loyaltyDiscount && (
              <AvailMainSideSummaryLoyaltyDiscount loyaltyDiscount={loyaltyDiscount} loyaltyUser={loyaltyUser} loyalty={loyalty} forceSymbol={forceSymbol}/>
            )}

            {!!promoCodeDiscount && (
              <AvailMainSideSummaryPromoCodeDiscount promoCodeDiscount={promoCodeDiscount} promoCode={promoCode} forceSymbol={forceSymbol} />
            )}

            {showTaxes && (
              <AvailMainSideSummaryTaxes taxes={taxes.included} summaryBreakdownMode={summaryBreakdownMode} included={true} forceSymbol={forceSymbol} />
            )}
          </div>

          <div className={classes.separator}></div>

          <div className={[classes.availPaymentBox, payments.length === 1 && !giftCodeDiscount ? classes.removeGap : ''].join(' ')}>
            <AvailMainSideSummaryTotalPrice totalPrice={totalPrice} forceSymbol={forceSymbol} text={'_%importe total%_'} />

            {stepCode !== 'confirmation' && (!!redeemPoints || !!giftCodeDiscount) && (
              <AvailMainSideSummaryEquivalentPrice totalPrice={totalPrice} removeGap={removeGap}/>
            )}

            {!!redeemPoints && (
              <AvailMainSideSummaryRedeemPoints redeemPoints={redeemPoints}/>
            )}

            {!!giftCodeDiscount && (
              <AvailMainSideSummaryGiftCodeDiscount giftCode={giftCode} giftCodeDiscount={giftCodeDiscount} forceSymbol={forceSymbol}/>
            )}

            {payments && payments.map((pay,key) => (
              <div key={key}>
                <AvailMainSideSummaryPay stepCode={stepCode} text={pay.text} value={pay.amount} isEquivalent={pay.isEquivalent} showRight={payments.length === 1} giftCodeDiscount={giftCodeDiscount} forceSymbol={forceSymbol}/>
              </div>
            ))}
          </div>

          {!!accumulatePoints && !showFrontRedeemPoints && (
            <>
              <div className={classes.separator}></div>

              <div className={[classes.availMainSideSummaryLoyaltyPoints, nothingBelow ? classes.removePaddingBottom : ''].join(' ')}>
                <AvailMainSideSummaryLoyaltyPoints accumulatePoints={accumulatePoints} />
              </div>
            </>
          )}

          {(taxes.nonIncluded.length > 0 || !!hotelInfo.get('city_tax')) &&
            <>
              <div className={classes.separator}></div>
              <div className={[classes.availMainSideSummaryTaxes, !penalties ? classes.removePaddingBottom : ''].join(' ')}>
                <AvailMainSideSummaryTaxes
                  taxes={taxes.nonIncluded}
                  included={false}
                  title={((['customerForm', 'confirmation'].includes(stepCode) && taxes.nonIncluded.length > 0) || !!hotelInfo.get('city_tax')) ? '_%información sobre impuestos%_' : null}
                  cityTax={hotelInfo.get('city_tax')}
                  forceSymbol={forceSymbol}
                />
              </div>
            </>
          }

          {penalties &&
            <AvailMainSideSummaryPenalties penalties={penalties} pms={pms} discountPercent={discountPercent} text={requiredPrepaymentText} stepCode={stepCode} />
          }

          {hotelInfo.get('country_iso_code') === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP && (
            <div className={classes.availMainSideSummaryHotelInfo}>
              <AvailMainSideSummaryHotelInfo />
            </div>
          )}

        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps, content) => {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
  const showTaxes = hotelInfo.get('show_taxes');
  const reservationObj = store.getIn(['customer', 'reservation'], false);

  /******* hotelAvail *******/
  const hotelAvail =
    stepCode === 'confirmation' && storage.get('hotel_avail')
      ? fromJS(storage.get('hotel_avail'))
      : store.getIn(['avail', hotelId, store.getIn(['hotels', hotelId, 'params', reservationAvailQuery(store).get("string_params")]), 'response']);
  if (hotelAvail && stepCode !== 'confirmation') {
    storage.set('hotel_avail', hotelAvail.toJS());
  }

  /******* totalAdults | totalChilds *******/
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  let totalAdults = 0;
  let totalChilds = 0;
  let childsInfo = List();
  if (reservationBlocks) {
    reservationBlocks.forEach(block => {
      const roomAvail = hotelAvail && hotelAvail.getIn([block.get('idx') - 1, block.get('room_id')]);
      totalAdults += roomAvail && roomAvail.get('adults', 0);
      totalChilds += roomAvail && roomAvail.get('childs', 0) + roomAvail.get('babies', 0);
      if(roomAvail && roomAvail.get('childs_info')?.size){
        childsInfo = childsInfo.merge(roomAvail.get('childs_info'));
      }
    });
  }


  /******* serviceAvailResponse *******/
  const serviceAvailResponse =
    stepCode === 'confirmation' && storage.get('service_avail') ? fromJS(storage.get('service_avail')) : store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
      'response'
    ]);
  if (serviceAvailResponse && stepCode !== 'confirmation') {
    storage.set('service_avail', serviceAvailResponse.toJS());
  }


  /******* SERVICES *******/
  const services = parseServices(hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse);
  let parsedServices = [];
  services && services.forEach(service => {
    const serviceInfo = serviceAvailResponse.get('services').find(availService => availService.get('id') === service.get('service_id'));
    const key = (service.get('service_id') + '-' + (service.get('stringDate') ? service.get('stringDate') : '')).replace(/\s+/g, '');

    parsedServices[key] = {
      serviceId: service.get('service_id'),
      serviceName: serviceInfo.get('name'),
      servicePrice: service.get('price'),
      quantity: service.get('quantity'),
      stringDate: service.get('stringDate') || '',
    };
  });


  /******* PROMO CODE DISCOUNT *******/

  let promoCodeDiscount = null;
  let promoCode;

  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;

  promoCode = (queryParams && queryParams.get('promotion_code')) || queryParams.get('avail_code');

  if (queryParams && promoCode && hotelAvail && reservationBlocks) {
    promoCodeDiscount = reservationBlocks.reduce((value, block, idx) => {
      const selectedRateAvail = hotelAvail.getIn([
        idx,
        block.get('room_id'),
        'boards',
        block.get('board_id'),
        block.get('ref_type')
      ]);

      const computedDiscountValue =
        selectedRateAvail &&
        selectedRateAvail.get('days').reduce((total, day) => {
          const findDiscount = day.get('discounts', List()).find(discount => {
            return discount.get('is_promotion_code');
          });
          let discountValue = 0;

          if (findDiscount) {
            const baseDiscountValue = Math.abs(findDiscount.get('amount', 0));
            if (!day.get('taxes_included') && hotel.get('show_taxes')) {
              discountValue = baseDiscountValue + (baseDiscountValue * day.get('tax_percent')) / 100;
            } else if (day.get('taxes_included') && !hotel.get('show_taxes')) {
              discountValue = baseDiscountValue / (day.get('tax_percent') / 100 + 1);
            } else {
              discountValue = findDiscount.get('amount', 0);
            }
          }

          return total + (discountValue || 0);
        }, 0);
      return value + computedDiscountValue;
    }, 0);
    if (promoCodeDiscount > 0) {
      promoCodeDiscount *= -1;
    }
  }


  /********** GIFT CODE DISCOUNT **********/

  const amountPromoPaid = reservationObj.getIn(['payment', 'amount_promo_paid'], 0);
  let giftCode = null;
  let giftCodeDiscount = 0;

  var showFrontRedeemPoints = false;

  if(reservationObj &&
    reservationObj.getIn(["customer", "guest_booker"]) &&
    reservationObj.getIn(["customer", "guest_booker"]).size &&
    reservationObj.getIn(["customer", "guest_booker"]).size > 0) {
    showFrontRedeemPoints = true;
  }

  const redeemPoints  = reservationObj.getIn(["loyalty", "redeem_points"], 0);

  if (amountPromoPaid > 0 && reservationObj.getIn(['gift_voucher', 'code'], '') !== '') {
    giftCodeDiscount = amountPromoPaid * -1;
    giftCode = reservationObj.getIn(['gift_voucher', 'code']);
  }

  const refundable = isRefundable(
    hotelAvail,
    reservationBlocks,
    parseServices(hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse),
    serviceAvailResponse,
    hotel.get('management_group_id'),
    stepCode === 'confirmation'
  )


  /******* PENALTIES *******/
  let requiredPrepayment = 0;
  let requiredPrepaymentType = false;
  let requiredPrepaymentValue = false;

  if (reservationBlocks) {
    reservationBlocks.forEach(block => {
      requiredPrepayment += block.get('required_prepayment', 0);
      if (!requiredPrepaymentType) {
        requiredPrepaymentType = block.get('required_prepayment_type', '');
        requiredPrepaymentValue = block.get('required_prepayment_value', 0);
      }
    });
  }

  if (reservationObj) {
    requiredPrepayment = 0;
    requiredPrepaymentType = false;
    requiredPrepaymentValue = false;
    reservationObj.get('blocks', List()).forEach(block => {
      requiredPrepayment += block.get('required_prepayment', 0);
      if (!requiredPrepaymentType) {
        requiredPrepaymentType = block.get('required_prepayment_type', '');
        requiredPrepaymentValue = block.get('required_prepayment_value', 0);
      }
    });
  }

  let fullFreeReservation = false;
  const firstPenalty = reservationObj && reservationObj.getIn(['penalties', 0]);
  if (firstPenalty) {
    fullFreeReservation = (firstPenalty.get('release', null) === 23976 && firstPenalty.get('type', null) === 'percentage'
      && firstPenalty.get('value', null) === 0 && firstPenalty.get('show_as', null) === 'days');
  }

  return {
    // GENERAL
    stepCode,
    hotelInfo: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
    hotelAvail: is(List, hotelAvail) && hotelAvail.size > 0 && hotelAvail,
    reservationBlocks,
    showTaxes,
    hotelConfig: contextualizeAppConfig(store, hotelId),
    langActive: store.getIn(['customer', 'lang_info','code']),
    availHotel: store.getIn(['avail', hotelId, store.getIn(['hotels', hotelId, 'params', reservationAvailQuery(store).get("string_params")]), 'response'], null),
    forceHotelCurrency: stepCode === 'confirmation',
    reservationObj: reservationObj.size ? reservationObj : false,

    // ROOMS
    totalAdults,
    totalChilds,
    childsInfo,
    staticRooms: store.getIn(['hotels', hotelId, 'rooms'], List()),
    nights: queryParams.get('stay_length', 1),

    // SERVICES
    serviceAvailResponse,
    parsedServices,
    reservationTotals: reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store),

    // LOYALTY DISCOUNT
    loyaltyDiscount: getLoyaltyDiscount(store),
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data','loyalty'], null),

    // PROMO CODE DISCOUNT
    promoCodeDiscount: promoCodeDiscount,
    promoCode: promoCode,

    // GIFT CODE DISCOUNT
    giftCode,
    giftCodeDiscount,

    // REDEEM POINTS
    redeemPoints,

    // TOTAL PRICES
    refundable,
    payformCode: reservationObj.getIn(['payment', 'payform_code'], 0),
    totalPointsPrice: reservationObj.getIn(["loyalty", "total_points_price"], 0),

    // LOYALTY POINTS
    accumulatePoints: getSTPoints(store,showFrontRedeemPoints),
    showFrontRedeemPoints,

    //PENALTIES
    requiredPrepayment,
    requiredPrepaymentValue,
    requiredPrepaymentType,
    fullFreeReservation,
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
    managementGroupID: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id'),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['reservationConfirmed']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'stepCode',
    'reservationConfirmed',
    'hotelInfo',
    'hotelAvail',
    'reservationBlocks',
    'showTaxes',
    'hotelConfig',
    'langActive',
    'availHotel',
    'forceHotelCurrency',
    'reservationObj',

    // ROOMS
    'totalAdults',
    'totalChilds',
    'childsInfo',
    'staticRooms',
    'nights',

    // SERVICES
    'serviceAvailResponse',
    'parsedServices',
    'reservationTotals',

    // LOYALTY DISCOUNT
    'loyaltyDiscount',
    'loyaltyUser',
    'loyalty',

    // PROMO CODE DISCOUNT
    'promoCodeDiscount',
    'promoCode',

    // GIFT CODE DISCOUNT
    'giftCode',
    'giftCodeDiscount',

    // REDEEM POINTS
    'redeemPoints',

    // TOTAL PRICES
    'refundable',
    'payformCode',
    'totalPointsPrice',

    // LOYALTY POINTS
    'accumulatePoints',
    'showFrontRedeemPoints',

    //PENALTIES
    'requiredPrepayment',
    'requiredPrepaymentValue',
    'requiredPrepaymentType',
    'fullFreeReservation',
    'currencies',
    'langInfo',
    'currentCurrencyCode',
    'hotelCurrencyCode',
    'managementGroupID'
]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummary);
